<mat-card fxFlex fxLayout="row nowrap">
    <mat-card-title
        id="widgetTitle"
        class="widgetBlock"
        fxFlex="0 0 50%"
        fxLayoutAlign="center center"
        [ngStyle]="{ background: backgroundColor }"
        (click)="onTitleClick()"
    >
        <h2 fxFlex>
            <span class="itemCountTitle">{{ totalCount }}</span> <br />
            <span class="itemCountText">{{ title }}</span>
        </h2>
    </mat-card-title>
    <div class="widgetBlock" fxLayout="column nowrap" fxFlex="1 1 50%" fxLayoutAlign="center center">
        <div fxFlex="1 0 auto" class="itemCountDetails" fxLayout="column nowrap" fxLayoutAlign="center left">
            <div
                *ngFor="let item of statusItems?.statusItems"
                class="statusItem {{ item?.label | lowercase }}"
                [ngStyle]="{ color: item?.color }"
            >
                <mat-icon *ngIf="item?.icon" svgIcon="cc-{{ item?.icon }}" class="statusItemIcon"></mat-icon>
                <span class="statusItemLabel">{{ item?.itemCount }}&nbsp;<span class="label" [innerHTML]="item?.label"></span></span>
            </div>
        </div>
        <a fxFlex="0 0 auto" *ngxPermissionsOnly="['manageWidgetAction']" class="actionItem" (click)="onActionItemClick()">{{
            actionItem
        }}</a>
    </div>
</mat-card>
